export default {
  usertypes: [],
  autocomplete_data : [],
  autocomplete_selected : {},
  usertype:[],
  selected_usertype : {},
  usertype_status:[]
}
